/*global WebView*/

module.exports = [
    {
        order: 1,
        type: "startup", //called on startup
        interceptor: function (app, callback){
            app.context.api.db.multiread({
                iz_custom_view: { search: {active: true}, orderBy : "sequence"}
            }, function(err, reads){
                if(err){ return callback(err) ; }
                var customizations = reads.iz_custom_view ;
                var custoByView = {};
                customizations.filter(function(c){ return c.type !== "startup" ;}).forEach(function(custo){
                    if(!custoByView[custo.view]){
                        custoByView[custo.view] = [] ;
                    }
                    custoByView[custo.view].push(custo) ;
                }) ;
                Object.keys(custoByView).forEach(function(view){
                    WebView.registerCustomizations(view, custoByView[view]) ;
                }) ;

                customizations.filter(function(c){ return c.type === "startup" ;}).forEach(function(custo){
                    try{
                        var func = new Function(custo.code) ;
                        func() ;
                    }catch(err){
                        console.error("Error while run custo ", custo.code, err) ;
                    }
                }) ;

                callback() ;
            }) ;
        }
    }
];